<template>
  <ul id="related-list" v-if="listData.length">
    <li
      v-for="(related, index) in listData"
      :key="index"
      :class="[isActive(related.name) ? 'active' : '']"
    >
      <template v-if="related.found">
        <img 
          :src="activeIcon" 
          alt="" 
          v-show="isActive(related.name)" 
          class="icon__active"
        >
        <a @click.stop="$emit('change-related', index)">
          <img 
            :src="icon" 
            class="icon__main" 
            :class="{ hidden: isActive(related.name) }" 
          />
          <p>{{ related.name }}</p>
        </a>
      </template>
      <template v-else>
        <img :src="notFoundIcon" class="no-found">
      </template>
    </li>
  </ul>
</template>

<script>
/**
 * RelatedList Component following SOLID principles
 * Single Responsibility: Display and manage related person selection
 * Open/Closed: Extensible through props and events
 * Liskov Substitution: Can be replaced with any list component with same interface
 * Interface Segregation: Only exposes necessary props and events
 * Dependency Inversion: Depends on abstractions (props) not concrete implementations
 */
export default {
  name: 'RelatedList',

  props: {
    listData: {
      type: Array,
      required: true,
      default: function() { return []; }
    },
    activeName: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: function() { return require('@/assets/images/user.png'); }
    },
    activeIcon: {
      type: String,
      default: function() { return require('@/assets/images/select-related.png'); }
    },
    notFoundIcon: {
      type: String,
      default: ''
    }
  },

  computed: {
    iconActivatedStyles: function() {
      return {
        'background-image': 'url(' + this.activeIcon + ')'
      };
    }
  },

  methods: {
    isActive: function(name) {
      return name === this.activeName;
    }
  }
};
</script>

<style lang="scss" scoped>
#related-list {
  margin: 0;
  padding: 1rem;
  width: 100%;
  list-style: none;
  white-space: nowrap;
  overflow-y: scroll;
  display: flex;

  li {
    flex-shrink: 0;
    flex-basis: 60px;
    display: inline-block;
    text-align: center;
    position: relative;
    margin: 0 5px;

    .icon__active {
      position: absolute;
      top: 0;
      left: 0;
      width: 60px;
      height: auto;
    }

    .icon__main {
      width: 60px;
      height: auto;
      
      &.hidden {
        visibility: hidden;
      }
    }

    .no-found {
      display: block;
      width: 60px;
      height: auto;
      margin: 0 auto;
    }
    
    a {
      display: block;
      position: relative;
      color: #000000;
      text-decoration: none;
      cursor: pointer;
      
      &:hover {
        opacity: 0.8;
      }
      
      p {
        margin: 0.5rem 0 0 0;
        font-size: 0.9rem;
        font-weight: 500;
      }
    }
    
    }
}

// Responsive design
@media (max-width: 768px) {
  #related-list {
    padding: 0.5rem;
    
    li {
      flex-basis: 50px;
      margin: 0 3px;
      
      .icon__active,
      .icon__main,
      .no-found {
        width: 50px;
      }
      
      a p {
        font-size: 0.8rem;
      }
    }
  }
}
</style>